import { Injectable, NgZone } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SpeechService {
  recognition: any;
  isListening = false;
  activeField: string | null = null;

  private currentInterimCallback: ((interimText: string) => void) | null = null;
  private currentFinalCallback: ((finalText: string) => void) | null = null;
  private pendingStart: { field: string; onInterim: (t: string) => void; onFinal: (t: string) => void } | null = null;

  constructor(private zone: NgZone) {
    const SpeechRecognition = (window as any).webkitSpeechRecognition || (window as any).SpeechRecognition;
    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.lang = 'fr-FR';
      this.setupHandlers();
    }
  }

  private setupHandlers() {
    this.recognition.onresult = (event: any) => {
      let interimTranscript = '';
      let finalTranscript = '';

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const transcript = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          finalTranscript += transcript;
        } else {
          interimTranscript += transcript;
        }
      }

      this.zone.run(() => {
        if (finalTranscript && this.currentFinalCallback) {
          this.currentFinalCallback(finalTranscript);
        }
        if (interimTranscript && this.currentInterimCallback) {
          this.currentInterimCallback(interimTranscript);
        }
      });
    };

    this.recognition.onerror = (event: any) => {
      console.error('Erreur reconnaissance vocale:', event.error);
      this.zone.run(() => {
        this.isListening = false;
        this.activeField = null;
      });
    };

    this.recognition.onend = () => {
      this.zone.run(() => {
        this.isListening = false;
        this.activeField = null;

        if (this.pendingStart) {
          const { field, onInterim, onFinal } = this.pendingStart;
          this.pendingStart = null;
          this.doStart(field, onInterim, onFinal);
        }
      });
    };
  }

  private doStart(field: string, onInterim: (t: string) => void, onFinal: (t: string) => void) {
    this.activeField = field;
    this.currentInterimCallback = onInterim;
    this.currentFinalCallback = onFinal;
    this.isListening = true;
    try {
      this.recognition.start();
    } catch (e) {
      console.error('Erreur au démarrage:', e);
      this.isListening = false;
    }
  }

  start(field: string, onInterim: (t: string) => void, onFinal: (t: string) => void) {
    if (!this.recognition) {
      alert("La reconnaissance vocale n'est pas supportée sur ce navigateur (utilisez Chrome/Edge).");
      return;
    }

    if (this.isListening) {
      this.pendingStart = { field, onInterim, onFinal };
      this.recognition.stop();
      return;
    }

    this.doStart(field, onInterim, onFinal);
  }

  stop() {
    if (this.recognition) {
      this.recognition.stop();
    }
  }

  toggle(field: string, onInterim: (t: string) => void, onFinal: (t: string) => void) {
    if (this.isListening && this.activeField === field) {
      this.stop();
    } else {
      this.start(field, onInterim, onFinal);
    }
  }
}